import { WidgetSchema } from 'features/views/LayoutEditor/types'
import { getRequiredFieldsFromField } from 'features/views/LayoutEditor/utils'

import { RelatedRecordWidget } from './RelatedRecordWidget'
import { RelatedRecordWidgetAdminControls } from './RelatedRecordWidgetAdminControls'
import { RelatedRecordWidgetFieldRef, RelatedRecordWidgetType } from './types'

export const RelatedRecordWidgetMeta: WidgetSchema<RelatedRecordWidgetType> = {
    category: 'data',
    label: 'Record card',
    icon: 'FileText',
    component: RelatedRecordWidget,
    adminControlsComponent: RelatedRecordWidgetAdminControls,
    defaultAttrs: {
        fields: [],
        showAllFields: false,
        showFieldIcon: false,
        labelPlacement: 'top',
        alignment: 'left',
    },
    requireFields: (attrs, fields) => {
        const { targetField } = attrs

        if (!targetField) return []

        const targetFieldType = targetField?.type ?? 'field'

        if (targetFieldType === 'field') {
            const field = fields?.get((targetField as RelatedRecordWidgetFieldRef).fieldSid)
            if (!field) return []

            return getRequiredFieldsFromField(field)
        }

        return []
    },
}
